import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sc-confirmation-dialog',
  templateUrl: './sc-confirmation-dialog.component.html',
  styleUrls: ['./sc-confirmation-dialog.component.scss']
})
export class ScConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ScConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public message: string) {}
}
